import React from "react";
import { connect } from "react-redux";
import { FlatButton } from "material-ui";
import { refreshView as refreshViewAction } from 'admin-on-rest';
import DeleteIcon from "material-ui/svg-icons/action/delete";
import compose from "recompose/compose";

const Config = require('../../config');

class DeleteButton extends React.Component {
  handleClick = () => {
    const { items, refreshView } = this.props;
    const body = {
      token: localStorage.getItem('auth_token'),
      items: items.join(',')
    }
    const requestURL = `${Config.serverUrl}/api/deleteComplaints`;
    console.log(requestURL);
    console.log(body);
    const options = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(body),
    };
    fetch(requestURL, options)
      .then(response => response.json())
      .then(result => {
        refreshView();
      });
  };

  render() {
    return (
      <FlatButton
        primary
        label="Delete"
        icon={<DeleteIcon />}
        onClick={this.handleClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.customReducer.items
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    refreshView: () => {
      dispatch(refreshViewAction());
    },
  }
}

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(DeleteButton);



// WEBPACK FOOTER //
// ./src/custom/Toggle/DeleteButton.js